module.exports = __webpack_public_path__ + "img/81.12910c6f.jpg";